import React, {Component} from 'react';
import Navbar from "../components/base/Navbar";
import Footer from "../components/base/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faServer } from '@fortawesome/fontawesome-free-solid'

class Error extends Component {
    render() {
        return (
            <div className="bg-gray-200 pt-24 bg-center">

                <Navbar/>

                <div className="p-8 px-4 lg:px-24 w-full flex flex-col">
                    <div className="flex flex-row w-full px-8 rounded-t-3xl bg-white text-gray-700 font-bold">
                        <div className="py-4 flex flex-col">
                            <div className="text-lg uppercase">us-arbeitsrecht.de</div>
                            <div className="text-3xl text-blue-500 uppercase font-bold">Server Error</div>
                        </div>
                    </div>
                    <div className="w-full px-8 bg-white rounded-b-3xl py-4">
                        <div className="text-base mt-6 mb-6 text-gray-700">
                        <span className="prose prose-invert">
                            <div>
                                <h1 className="font-bold text-3xl">404: Page Not Found
                                    <FontAwesomeIcon className="mx-2" icon={faServer}/>
                                </h1>
                                <br/>
                                <p className="text-xl">Deine Seite konnte nicht gefunden werden!</p>
                                <br/>
                                <p className="text-xl">Sollte dies ein Fehler sein, kontaktieren sie unverzüglich einen Server Administrator</p>
                                <br/>
                                <hr/>
                                <br/>
                                <br/>
                                <p>Was Kannst du machen:</p>
                                <br/>
                                <br/>
                            </div>

                            <div className="text-base mt-6 mb-6 text-gray-700 inline">
                                <a href="" className="underline hover:text-blue-500 cursor-pointer">Startseite</a>
                                <a onClick={reloadPage} className="mx-8 underline hover:text-blue-500 cursor-pointer">Seite neuladen</a>
                                <a onClick={backPage} className="underline hover:text-blue-500 cursor-pointer">Zurück zur letzten Seite</a>
                            </div>

                            <br/>
                            <br/>

                        </span>
                        </div>
                    </div>
                </div>

                <Footer/>

            </div>
        );
    }
}

function reloadPage() {
    window.location.reload();
}

function backPage() {
    window.history.back();
}

export default Error;